var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdLight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "id card",
    id: "id_card",
    style: {
      fill: "white",
      stroke: "black",
      backgroundColor: "#ffffff"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21,3H3A3,3,0,0,0,0,6V18a3,3,0,0,0,3,3H21a3,3,0,0,0,3-3V6A3,3,0,0,0,21,3Zm1,15a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1V6A1,1,0,0,1,3,5H21a1,1,0,0,1,1,1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.38,11.8a3,3,0,1,0-4.76,0C3.91,13.08,4,14.68,4,16a1,1,0,0,0,1,1h6a1,1,0,0,0,1-1C12,14.79,12.15,13.13,10.38,11.8ZM7,10a1,1,0,0,1,2,0A1,1,0,0,1,7,10ZM6,15a2,2,0,0,1,4,0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19,7H14a1,1,0,0,0,0,2h5A1,1,0,0,0,19,7Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19,11H14a1,1,0,0,0,0,2h5A1,1,0,0,0,19,11Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19,15H14a1,1,0,0,0,0,2h5A1,1,0,0,0,19,15Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdLight);
export default __webpack_public_path__ + "static/media/id_light.35f0c89b7bb9bca0f888fd3c1a1bf322.svg";
export { ForwardRef as ReactComponent };